export { default as Form } from 'cost_centers/components/form/CostCenterForm';



// WEBPACK FOOTER //
// src/modules/secured/modules/cost_centers/components/form/index.js